export interface CernerExternal extends External {
  DiscernObjectFactory?: unknown;
}

/**
 * Determine if application is rendered in PowerChart.
 * `DiscernObjectFactory` propery is provided by the
 * external environment and not controlled by us.
 * Reference: https://fhir.cerner.com/smart/#embedded-in-powerchart
 * @return null or true/false
 */
export const isInPowerChart = () => {
  const windowExternal = window && window.external;
  const cernerExternal = (windowExternal as CernerExternal)
    ?.DiscernObjectFactory;
  return windowExternal && typeof cernerExternal !== "undefined";
};
